// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IOrganizationAdminSummary {
	id: string | undefined;

	name: string | undefined;

	deviceCount: number;

	userCount: number;

	locationCount: number;

	canBeDeleted: boolean;

	$type?: string | undefined;
}
export class OrganizationAdminSummary {
	constructor(data?: IOrganizationAdminSummary) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	id: string | undefined;

	name: string | undefined;

	deviceCount: number = 0;

	userCount: number = 0;

	locationCount: number = 0;

	canBeDeleted: boolean = false;

	static $type: string = "CoreApi.Models.View.OrganizationAdminSummary, ";
	$type?: string | undefined = OrganizationAdminSummary.$type;
}

